import { Text } from 'react-native'
import { useTranslation } from 'react-i18next'
import { CashierSuccessView } from '../shared/CashierSuccessView'

export interface StampTransactionResult {
  stampsAdded: number
  memberFullName: string
  memberFirstName: string
  newTotal: number
  stampTarget: number
  rewardsUnlocked: number
  rewardName: { en: string; sv: string } | null
}

interface StampSuccessViewProps {
  result: StampTransactionResult
  onScanNext: () => void
  onDone: () => void
}

export function StampSuccessView({ result, onScanNext, onDone }: StampSuccessViewProps) {
  const { t, i18n } = useTranslation()
  const { stampsAdded, memberFullName, memberFirstName, newTotal, stampTarget, rewardsUnlocked, rewardName } = result
  const lang = i18n.language === 'sv' ? 'sv' : 'en'
  const localizedRewardName = rewardName ? (rewardName[lang] || rewardName.en) : ''

  const stampsLabel = stampsAdded === 1
    ? t('stampAwarding.success.stampsSingle', { fullName: memberFullName })
    : t('stampAwarding.success.stamps', { count: stampsAdded, fullName: memberFullName })

  return (
    <CashierSuccessView
      title={t('stampAwarding.success.title')}
      scanNextLabel={t('stampAwarding.success.scanNext')}
      doneLabel={t('stampAwarding.success.done')}
      onScanNext={onScanNext}
      onDone={onDone}
    >
      <Text className="text-base lg:text-lg text-secondary text-center">
        {stampsLabel}
      </Text>

      <Text className="text-base lg:text-lg text-secondary text-center">
        {t('stampAwarding.success.newTotalPrefix', { firstName: memberFirstName })}{' '}
        <Text className="font-bold text-accent">{newTotal} / {stampTarget}</Text>
        {' '}{t('stampAwarding.success.newTotalSuffix')}
      </Text>

      {rewardsUnlocked === 1 && (
        <Text className="text-base lg:text-lg font-semibold text-accent text-center">
          {t('stampAwarding.success.rewardUnlocked', { rewardName: localizedRewardName })}
        </Text>
      )}
      {rewardsUnlocked > 1 && (
        <Text className="text-base lg:text-lg font-semibold text-accent text-center">
          {t('stampAwarding.success.rewardsUnlocked', { count: rewardsUnlocked, rewardName: localizedRewardName })}
        </Text>
      )}
    </CashierSuccessView>
  )
}